import React, { forwardRef } from 'react';

import { CloseXIcon } from '@_shared/icons';
import { Typography } from '@_shared/ui/Typography';

import * as S from './Button.style';
import { IButtonProps, ISingleInputFormPopupButtonProps } from './Button.types';
import { IPopupComponentDefaultProps } from './Popup.types';

const InformationPopupButtonContainer = forwardRef(
	(
		{ children }: IPopupComponentDefaultProps,
		ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
	) => <S.ButtonContainer ref={ref}>{children}</S.ButtonContainer>,
);
InformationPopupButtonContainer.displayName = 'InformationPopupButtonContainer';

const InformationPopupButton = forwardRef(
	(
		{ children, onClick, type }: IButtonProps,
		ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
	) => (
		<S.Button type={type} ref={ref} onClick={onClick}>
			<Typography
				type="title-large"
				color={type === 'confirm' ? 'orange-primary' : 'font-tertiary'}
			>
				{children}
			</Typography>
		</S.Button>
	),
);
InformationPopupButton.displayName = 'InformationPopupButton';

const SingleInputFormPopupSubmitButton = forwardRef(
	(
		{ children, disabled, onClick }: ISingleInputFormPopupButtonProps,
		ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
	) => (
		<S.SingleInputFormPopupSubmitButton
			ref={ref}
			type="submit"
			disabled={disabled}
			onClick={onClick}
		>
			<Typography type="title-small" color={disabled ? 'font-tertiary' : 'orange-primary'}>
				{children}
			</Typography>
		</S.SingleInputFormPopupSubmitButton>
	),
);
SingleInputFormPopupSubmitButton.displayName = 'SingleInputFormPopupSubmitButton';

function PromotionPopupCloseButton({ onClose }: { onClose: () => void }) {
	return (
		<S.CloseIconWrapper onClick={onClose}>
			<CloseXIcon />
		</S.CloseIconWrapper>
	);
}

export {
	InformationPopupButtonContainer,
	InformationPopupButton,
	PromotionPopupCloseButton,
	SingleInputFormPopupSubmitButton,
};
